module.exports = __webpack_public_path__ + "media/images/service d'étage-c1c92aba44eb1008583d59acbf94b8df.svg";